import { useTreeItemState } from "@mui/x-tree-view";
import clsx from "clsx";

import { CoAppNavItem } from "./styled/coapp-nav-tree.styled";

export default function CustomContent(props, ref) {

	const {
		label,
		itemId,
		classes,
		className,
		onClick
	} = props;

	const {
		disabled,
		expanded,
		selected,
		handleSelection,
		preventSelection
	} = useTreeItemState(itemId);

	const handleItemClick = (event) => {
		onClick(event, handleSelection);
		handleSelection(event);
	};

	return (
		<div
			className={clsx(className, classes.root, {
				[classes.expanded]: expanded,
				[classes.selected]: selected,
				[classes.disabled]: disabled,
			})}
			onMouseDown={preventSelection}
			onClick={handleItemClick}
			ref={ref}
		>
			<CoAppNavItem title={label}>{label}</CoAppNavItem>
		</div>
	);
}